/** Returns the number of goods by Id */
const getGoodsByKey = (goods: string): Record<string, number> => {
    return [...goods].reduce((acc: Record<string, number>, char: string) : Record<string, number> => {
        const oldCount = acc[char] || 0;
        return { ...acc, [char]: oldCount + 1 }
    }, {});
};

export default getGoodsByKey;
